import axios from 'axios';
import { getBearerToken } from '@cj-platform/authentication-browser';

export const getData = async url => {
  const jsonCall = await axios.get(url, {
    headers: {
      Authorization: `Bearer ${await getBearerToken()}`
    }
  })
  return jsonCall.data
};

export const postData = async (url, body) => {
  const httpRequestConfig = {
    headers: {
      Authorization: `Bearer ${await getBearerToken()}`,
    }
  }
  const jsonCall = await axios.post(url, body, httpRequestConfig)
  return jsonCall.data
}
